import { render, staticRenderFns } from "./TipsZonglan.vue?vue&type=template&id=0ac3aae8&scoped=true"
import script from "./TipsZonglan.vue?vue&type=script&lang=js"
export * from "./TipsZonglan.vue?vue&type=script&lang=js"
import style0 from "./TipsZonglan.vue?vue&type=style&index=0&id=0ac3aae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac3aae8",
  null
  
)

export default component.exports